import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNdd65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_65: Record<
  Exclude<PageIdWoofzNdd65, PageIdWoofzNdd65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NDD_65]: {
    id: PageId.SUBSCRIPTIONS_NDD_65,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NDD_65]: {
    id: PageId.CHAT_UPSELL_NDD_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NDD_65]: {
    id: PageId.UPSELL_NDD_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NDD_65]: {
    id: PageId.DOWNLOAD_NDD_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
